import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000
})

request.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let { data, status } = error.response

    if (status !== 422) {
      notification.error(data.message)
    }

    return Promise.reject(data.data)
  }
)

export default request
